import React from "react";
import ReactHtmlParser from "react-html-parser";
export default class Comp extends React.PureComponent {
  render = () => (
    <div style={{ cursor: "initial" }} className={"post_item"}>
      <img className="cover" alt="" src={this.props.thumbnail} />
      <div className="holder">
        <p className="title"> {this.props.title}</p>
      </div>
      <div className="content_holder">
        {this.props.content_html
          ? ReactHtmlParser(
              this.props.content_html
                .split("&lt;video")
                .join("<video")
                .split('type="video/mp4"&gt;')
                .join("/>")
            )
          : null}
      </div>
      {/* { 
        this.props.content ?
          this.props.content.map((item,key)=><p key={key} className='content_item'>{item.value}</p>)            
          : ''
      } */}
    </div>
  );
}
